<template>
  <div class="nx-image-preview-wrapper">
    <nx-image-focal-point
      v-if="focalPointFeatureEnabled"
      :src="value"
      :value="focalPoint"
      name="focalPoint"
    ></nx-image-focal-point>
    <div class="text-xs-center">
      <div class="nx-image-preview-wrapper__img mb-4">
        <nx-image
          :src="value"
          width="100%"
          height="500px"
        ></nx-image>
        <div class="nx-image-focal-point-preview" v-if="focalPoint"
             :style="{ top: `${focalPoint.top}%`, left: `${focalPoint.left}%` }">
          <v-icon medium color="white">adjust</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NxImage from '@/components/media/Image';
import get from 'lodash/get';
import NxImageFocalPoint from '@/modules/form/components/ImageFocalPoint';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-image-preview',
  components: { NxImage, NxImageFocalPoint },
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  props: {
    value: {
      type: [String],
    },
    focalPointEnabled: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['features']),
    focalPointFeatureEnabled() {
      if (this.focalPointEnabled === null) {
        return this.features.IMAGE_FOCAL_POINT;
      }
      return this.features.IMAGE_FOCAL_POINT && this.focalPointEnabled;
    },
    focalPoint() {
      return this.$getParentEditor().draft.focalPoint;
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-image-preview-wrapper__img {
  position: relative
  display: inline-block
}
</style>
